<template>
  <BaseModal ref="BaseModal" :destroyOnClose="false" @confirm="insert">
    <el-tabs
      v-model="activeName"
      class="qingdan-zimu"
      type="card"
      @tab-click="handleTabClick"
    >
      <el-tab-pane label="清单" name="qd">
        <el-tabs v-model="tabActive" type="card" @tab-click="handleTabClick">
          <el-tab-pane label="2013清单" name="1" key="1"></el-tab-pane>
          <el-tab-pane label="2024清单" name="2" key="2"></el-tab-pane>
          <el-tab-pane label="非国标清单" name="3" key="3"></el-tab-pane>
        </el-tabs>

        <LeftRightBox
          height="500px"
          class="page-container"
          :leftWidthDefault="250"
        >
          <div class="left" slot="left">
            <SimpleTable
              ref="qdLeftRef"
              table-code="qingdanzimuQdLeft"
              :loading="loadingQdLeft"
              :show-index="false"
              :allowMultiSelect="false"
              :columns="columnsQdLeft"
              :data="tableDataQdLeft"
              @row-select="handleRowSelectQdLeft"
            />
          </div>
          <div class="right" slot="right">
            <SimpleTable
              ref="qdRightRef"
              table-code="qingdanzimuQdRight"
              :loading="loadingQdRight"
              :show-index="false"
              :columns="columnsQdRight"
              :data="tableDataQdRight"
            />
          </div>
        </LeftRightBox>
      </el-tab-pane>
      <!-- <el-tab-pane label="子目" name="zm">
        <LeftRightBox
          height="500px"
          class="page-container"
          :leftWidthDefault="250"
        >
          <div class="left" slot="left">
            <el-select v-model="zmActive" placeholder="请选择">
              <el-option
                v-for="item in ZmOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <SimpleTable
              ref="zmLeftRef"
              table-code="qingdanzimuZmLeft"
              :loading="loadingZmLeft"
              :show-index="false"
              :allowMultiSelect="false"
              :columns="columnsZmLeft"
              :data="tableDataZmLeft"
              @row-select="handleRowSelectZmLeft"
            />
          </div>
          <div class="right" slot="right">
            <SimpleTable
              ref="zmRightRef"
              table-code="qingdanzimuZmRight"
              :loading="loadingZmRight"
              :show-index="false"
              :columns="columnsZmRight"
              :data="tableDataZmRight"
            />
          </div>
        </LeftRightBox>
      </el-tab-pane> -->
    </el-tabs>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import {
  columnsQdLeft,
  columnsQdRight,
  columnsZmLeft,
  columnsZmRight
} from './config'
import { sortRecords } from '@/utils/index'

export default {
  name: 'QingDanZiMu',
  components: { BaseModal, SimpleTable, LeftRightBox },
  data() {
    return {
      activeName: 'qd',

      tabActive: '2',

      // 页面数据
      columnsQdLeft,
      tableDataQdLeft: [],
      columnsQdRight,
      tableDataQdRight: [],
      columnsZmLeft,
      tableDataZmLeft: [],
      columnsZmRight,
      tableDataZmRight: [],

      ZmOptions: [],
      zmActive: '',

      // 页面loading
      loadingQdLeft: false,
      loadingQdRight: false,
      loadingZmLeft: false,
      loadingZmRight: false
    }
  },
  watch: {
    zmActive: {
      handler(newVal) {
        this.getZmTableLeft()
      }
    }
  },
  created() {},
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    // 显示弹窗
    async show(options = {}) {
      this.options = { ...options }

      this.tableDataQdLeft = []
      this.tableDataQdRight = []
      this.tableDataZmLeft = []
      this.tableDataZmRight = []

      this.handleTabClick()

      this.$refs.BaseModal.show(
        JSON.parse(
          JSON.stringify({
            title: this.options.title,
            width: '1200px',
            confirmText: '插入'
          })
        )
      )
    },

    handleTabClick() {
      if (this.activeName === 'qd') {
        this.getQdTableLeft()
      } else {
        this.getZmOptions()
      }
    },

    handleRowSelectQdLeft(row) {
      this.getQdTableRight(row[0][0]?.originData)
    },

    handleRowSelectZmLeft(row) {
      this.getZMTableRight(row[0][0]?.originData)
    },

    async getQdTableLeft() {
      this.loadingQdLeft = true
      const res = await this.$service.get('/bill-library/listAll', {
        type: this.tabActive
      })
      this.tableDataQdLeft = sortRecords(res?.data || [])
      this.$refs.qdLeftRef.initialized(0, 1)
      this.loadingQdLeft = false
    },
    async getQdTableRight(row = {}) {
      this.loadingQdRight = true
      const res = await this.$service.get(
        '/bill-library/detail',
        {
          billLibraryId: row?.id,
          type: this.tabActive
        },
        { code: 'getQdTableRight' }
      )
      this.tableDataQdRight = sortRecords(res?.data || [])
      this.loadingQdRight = false
    },

    // 子目
    async getZmOptions() {
      const res = await this.$service.get('/baseQuotaLibrary/queryList')
      this.ZmOptions = sortRecords(res?.data || [])
      this.zmActive = this.ZmOptions[0].id
      this.getZmTableLeft()
    },

    async getZmTableLeft() {
      this.loadingZmLeft = true
      const res = await this.$service.get(
        `/baseQuotaLibrary/queryBaseQuotaClassifyList/${this.zmActive}`
      )
      this.tableDataZmLeft = sortRecords(res?.data || [])
      this.$refs.zmLeftRef.initialized(1, 1) // 选中第一行
      this.loadingZmLeft = false
    },
    async getZMTableRight(row = {}) {
      if (!row.id) return
      this.loadingZmRight = true
      const res = await this.$service.get(
        `/baseQuotaLibrary/queryBaseQuotaItemList/${row.id}`,
        {},
        { code: 'getZMTableRight' }
      )
      this.tableDataZmRight = sortRecords(res?.data || [])
      this.loadingZmRight = false
    },

    // 查询人材机 一起插入数据
    async getZMResourceTableRight(row = {}) {
      if (!row.id) return
      const res = await this.$service.get(
        `/baseQuotaLibrary/queryBaseQuotaResourceList/${row.id}`
      )
      row.resourceList = sortRecords(
        res?.data.map((e, i) => ({
          ...e,
          ttnId: this.options.ttnId,
          newType: e.type,
          orderNum: i + 1,
          id: undefined
        })) || []
      )
    },

    async insert(close) {
      const arr = []
      const map = { qd: '项', zm: '定' }
      if (this.activeName === 'qd') {
        this.$refs.qdRightRef.getSelectData().forEach(e => {
          arr.push(e[0].originData)
        })
      } else if (this.activeName === 'zm') {
        this.$refs.zmRightRef.getSelectData().forEach(e => {
          arr.push(e[0].originData)
        })
        await Promise.all(arr.map(e => this.getZMResourceTableRight(e)))
      }

      if (!arr.length) return

      this.options.vm.handleInsert(
        arr.map(e => ({
          ...e,
          billLibraryDetailId: e.id,
          budgtId: this.options.budgtId,
          importRecordId: this.options.importRecordId,
          type: map[this.activeName],
          newType: map[this.activeName],
          projectName: e.name,
          projectDesc: e.spec,
          unit: e.measurementUnit || e.unit,
          baseConstructionGroupName: e.constructionGroupName,
          baseConstructionGroupId: e.constructionGroupId,
          id: undefined
        }))
      )

      close()
    }
  }
}
</script>

<style scoped lang="less">
.qingdan-zimu {
  ::v-deep .el-tabs__nav {
    background: #fff;
  }
  .left,
  .right {
    height: 100%;
    width: 100%;
  }
}
</style>
